import React from 'react';
import PropTypes from 'prop-types';

import OptionsStepContainer from '../copied/OptionsStepContainer';
import Options from '../copied/Options';
import Option from '../copied/Option';
import OptionElement from '../copied/OptionElement';
import Bubble from '../copied/Bubble';
import Image from '../copied/Image';
import ImageContainer from '../copied/ImageContainer';
import TextStepContainer from '../copied/TextStepContainer';
import Decorate from '../elements/Decorate';

import '../../styles.css';

I18nOptions.propTypes = {
  previousStep: PropTypes.object,
  step: PropTypes.object,
  steps: PropTypes.object,
  triggerNextStep: PropTypes.func,

  i18nOptions: PropTypes.array,
  options: PropTypes.array,
};

function I18nOptions({triggerNextStep,step,i18nOptions}) {

  const handleClick = (option) => {
    // if (DebugService.getInstance().enabled) console.log('I18nOptions - handleClick',option);
    const nextIntentInstructions = {value:option.value, trigger: option.trigger};
    triggerNextStep(nextIntentInstructions);
  };

  // si on a choisit, on affiche uniquement la réponse
  if (step.value !== undefined) {
    const srcAvatar = "data:image/svg+xml,%3csvg viewBox='-208.5 21 100 100' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ccircle cx='-158.5' cy='71' fill='%23F5EEE5' r='50'/%3e%3cdefs%3e%3ccircle cx='-158.5' cy='71' id='a' r='50'/%3e%3c/defs%3e%3cclipPath id='b'%3e%3cuse overflow='visible' xlink:href='%23a'/%3e%3c/clipPath%3e%3cpath clip-path='url(%23b)' d='M-108.5 121v-14s-21.2-4.9-28-6.7c-2.5-.7-7-3.3-7-12V82h-30v6.3c0 8.7-4.5 11.3-7 12-6.8 1.9-28.1 7.3-28.1 6.7v14h100.1z' fill='%23E6C19C'/%3e%3cg clip-path='url(%23b)'%3e%3cdefs%3e%3cpath d='M-108.5 121v-14s-21.2-4.9-28-6.7c-2.5-.7-7-3.3-7-12V82h-30v6.3c0 8.7-4.5 11.3-7 12-6.8 1.9-28.1 7.3-28.1 6.7v14h100.1z' id='c'/%3e%3c/defs%3e%3cclipPath id='d'%3e%3cuse overflow='visible' xlink:href='%23c'/%3e%3c/clipPath%3e%3cpath clip-path='url(%23d)' d='M-158.5 100.1c12.7 0 23-18.6 23-34.4 0-16.2-10.3-24.7-23-24.7s-23 8.5-23 24.7c0 15.8 10.3 34.4 23 34.4z' fill='%23D4B08C'/%3e%3c/g%3e%3cpath d='M-158.5 96c12.7 0 23-16.3 23-31 0-15.1-10.3-23-23-23s-23 7.9-23 23c0 14.7 10.3 31 23 31z' fill='%23F2CEA5'/%3e%3c/svg%3e";
    // if (DebugService.getInstance().enabled) console.log('I18nOptions - step value',step.value);
    return (
      <TextStepContainer className={`rsc-ts ${true ? 'rsc-ts-user' : 'rsc-ts-bot'}`} user={true}>
        <Bubble
          className="rsc-ts-bubble"
          style={{}}
          user={true}
          showAvatar={true}
          isFirst={true}
          isLast={false}>
          {i18nOptions.map((option,index) => {
            // if (DebugService.getInstance().enabled) console.log('I18nOptions - ',{choice:step.value,option:option.value});
            if (step.value !== option.value)
              return null;
            return <div key={index}><Decorate label={option.label} /></div>;
          })}
        </Bubble>
        <ImageContainer className="rsc-ts-image-container" user={false}>
          <Image
            className="rsc-ts-image"
            style={{}}
            showAvatar={true}
            user={true}
            src={srcAvatar}
            alt={'avatar'}
          />
        </ImageContainer>
      </TextStepContainer>
    );
  }

  return (
    <OptionsStepContainer className="rsc-os">
      <Options className="rsc-os-options">
        {i18nOptions.map((option,index) => {
          return (
            <Option key={index} className="rsc-os-option">
              <OptionElement
                className="rsc-os-option-element"
                style={{}}
                user={false}
                onClick={() => handleClick(option)}>
                <Decorate label={option.label} />
              </OptionElement>
            </Option>
          );
        })}
      </Options>
    </OptionsStepContainer>
  );
}

export default I18nOptions;
